import React from 'react';
import './SlotManager.css';

const SlotManager = ({ children, visible = true }) => {
  if (!visible) {
    return null;
  }

  return <div className="slot-manager-shell">{children}</div>;
};

export default SlotManager;
